import { render, staticRenderFns } from "./HomeAboutUs.vue?vue&type=template&id=66666a98&scoped=true&"
import script from "./HomeAboutUs.vue?vue&type=script&lang=js&"
export * from "./HomeAboutUs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66666a98",
  null
  
)

export default component.exports